import React from 'react';

/*
  Thoughts and ideas for a different day
  * the problem with this hook is that the functions below are not stable. Need to wrap in useCallbacks so they become stable.
  *
  *
  * a lot of times we actually would like to cancel a useEffect rather than just a function. use effects probably should
  * cancel whenever dependencies change.
  * lots of examples to think about: search term changes and you run code that executes the search. should you cancel the state update if another search is executed?
 */


/**
 * useGuardedFunction
 *
 * Provides an interface for running functions if a check is passed.
 */
const useGuardedFunction = (initialValue = false) => {
  const guardRef = React.useRef(initialValue);

  const isPassingGuard = () => {
    return guardRef.current === true;
  };

  const guardFunction = (fn) => {
    return (...args) => {
      if (isPassingGuard()) {
        return fn(...args);
      }

      return undefined;
    };
  };

  const setGuardPassing = () => {
    guardRef.current = true;
  };

  const setGuardFailing = () => {
    guardRef.current = false;
  };

  return {
    isPassingGuard,
    guardFunction,
    setGuardPassing,
    setGuardFailing,
  };
};

export default useGuardedFunction;
